<template>
  <section>
    <div class="ext-text-container">
      {{ content }}
      <el-button size="mini" circle icon="el-icon-copy-document" @click="handleCopy" class="copy-btn"></el-button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExtText',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleCopy () {
      navigator.clipboard.writeText(this.content).then(() => {
        this.$message.success('复制成功')
      })
    }
  }
}
</script>

<style scoped>
.ext-text-container {
  white-space: pre-wrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", Courier, monospace;
  font-size: 12px;
  line-height: 1.6;
  max-width: 480px;
  max-height: 400px;
  overflow-y: auto;
  position: relative;
  color: var(--text-main);
  background: var(--bg-page);
  padding: 10px 38px 10px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
}

.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0.7;
  background-color: var(--bg-card) !important;
  border-color: var(--border-hover) !important;
  color: var(--text-muted) !important;
  transition: all 0.2s ease;
}

.copy-btn:hover {
  opacity: 1;
  color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  background-color: var(--bg-hover) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
</style>
